import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: true,
    name: 'signedFileName'
})
export class SignedFileNamePipe implements PipeTransform {

    transform(value: string): string {
        if (!value) return '';

        const lastDotIndex = value.lastIndexOf('.');

        if (lastDotIndex === -1) {
            // No extension
            return `${value}-signed`;
        }

        const name = value.substring(0, lastDotIndex);
        const extension = value.substring(lastDotIndex);

        return `${name}-signed${extension}`;
    }
}
